// Which notice of a value year a row belongs to — the notice_no column (migration 2026-10-21_notice_no_apply.sql).
//
// ⛔ EVERY READ AND WRITE OF THE NOTICE TABLES NAMES ITS NOTICE. parcel_appeals, parcel_appeal_deductions,
// parcel_appeal_decisions, parcel_appeal_deadlines, parcel_values, parcel_ratio_audit and file_exchange carry
// notice_no; a query that leaves it out mixes an additional notice's figures into the original's. The original
// Proposed notice is 0. Additional notices (Supplemental, Corrected, … — parcel_notices) are 1, 2, … (step 6).
// The Properties list, the Calendar and the card's savings read the original only. The reports read every notice and
// show the original's rows unless their "Notices: All notices" option is on (src/reports/parcelYearRows — step 8).
//
// No imports on purpose: the reports, the card, the scanner and the Calendar all use it.
export const ORIGINAL_NOTICE = 0;

// The parcel card keeps every per-level map (values, deductions, deadlines, decisions, edited flags) keyed by a
// SECTION KEY: the level itself for the original notice ('proposed', 'appeal_one') — so the original's paths are
// exactly what they were — and `${level}@${notice}` for an additional notice ('proposed@1', 'appeal_one@1').
export const sectionKey = (level, notice) => (notice ? `${level}@${notice}` : level);

export function parseSection(key) {
  const k = String(key);
  const at = k.indexOf('@');
  return at < 0 ? { level: k, notice: ORIGINAL_NOTICE } : { level: k.slice(0, at), notice: Number(k.slice(at + 1)) };
}

export const isOriginalSection = (key) => !String(key).includes('@');

// A per-section map with the additional notices' sections left out — what final level, savings and tax totals read.
export const originalOnly = (bySection) =>
  Object.fromEntries(Object.entries(bySection || {}).filter(([k]) => isOriginalSection(k)));
